export const listActions = <const>{
	GET_ZPRAVY_COUNT: 'getZpravyCount',
	NOVA_ZPRAVA: 'novaZprava',
	VYRIDIT_AKTIVOVAT_ZPRAVU: 'vyriditAktivovatZpravu',
	DO_POZNAMEK: 'doPoznamek',
	NACTI_ZPRAVU: 'nactiZpravu',
	ODESLAT_ZPRAVU: 'odeslatZpravu',
	ULOZIT_ZPRAVU: 'ulozitZpravu',
};

export const listMutations = <const>{
	SET_ZPRAVY_COUNT: 'setZpravyCount',
	NASTAV_DETAIL: 'nastavDetail',
	SET_IS_NOVA_ZPRAVA: 'setIsNovaZprava',
	ZAVRIT_DETAIL: 'zavritDetail',
	SET_VYRIDIT_AKTIVOVAT_ZPRAVU: 'setVyriditAktivovatZpravu',
	ODPOVEDET: 'odpovedet',
	ODPOVEDET_VSEM: 'odpovedetVsem',
	PREDAT_DAL: 'predatDal',
};
